import React from 'react';

import MuiSelect from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ArrowIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled } from '@mui/material/styles';

const StyledFormControl = styled(FormControl, {
  shouldForwardProp: (prop) => prop !== 'backgroundColor',
})(({ backgroundColor, theme }) => ({
  width: '100%',
  height: 40,
  background: backgroundColor || 'var(--color-surface)',
  borderRadius: 8,
  '& .MuiInputBase-root': {
    width: '100%',
  },
  '& .MuiOutlinedInput-root': {
    height: '100%',
    borderRadius: 8,
    background: backgroundColor || 'var(--color-surface)',

    '& fieldset': {
      borderColor: 'var(--color-border)',
    },

    '&:hover fieldset': {
      borderColor: 'var(--color-border)',
    },

    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
      borderWidth: 1,
    },
  },
}));

const StyledSelect = styled(MuiSelect)(() => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  '& .MuiSelect-select': {
    padding: '8px 24px 8px 10px',
    fontSize: 14,
    color: 'var(--color-text-primary)',
    '&.MuiSelect-select.Mui-disabled': {
      WebkitTextFillColor: 'var(--color-text-muted)',
    },
  },
  '& .MuiSelect-icon': {
    right: 12,
    color: 'var(--color-text-muted)',
  },
}));

const StyledMenuItem = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== 'width',
})(({ width }) => ({
  paddingTop: 6,
  paddingBottom: 6,
  fontSize: 14
  // width: width || '500px',
}));

const EndAdornmentContainer = styled(InputAdornment)(() => ({
  position: 'absolute',
  right: 16,
  // top: 'calc(50% - 2px)',
}));

const EndAdornmentText = styled('span')(() => ({
  color: 'var(--color-text-muted)',
  cursor: 'pointer',
}));

const Select = (props) => {
  const {
    value,
    onChange,
    options = [],
    label,
    required,
    defaultLabel,
    name,
    width,
    endAdornment = '',
    disabled = false,
    backgroundColor,
  } = props;

  return (
    <>
      {!!label && (
        <Box sx={{ display: 'flex', marginBottom: '2px' }}>
          <Typography sx={{ fontSize: '14px' }}>{label}</Typography>
          {required && <Typography sx={(theme) => ({ fontSize: '16px', ml: '1px', color: theme.palette.primary.main })}>*</Typography>}
        </Box>
      )}
      <StyledFormControl
        variant="outlined"
        backgroundColor={backgroundColor}
        sx={{ maxWidth: width || '100%' }}
        placeholder='Select'

      >
        <StyledSelect
          id="select-id"
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          displayEmpty
          placeholder='Select'
          disabled={disabled}
          MenuProps={{
            PaperProps: {
              elevation: 1,
              sx: (theme) => ({
                backgroundColor: 'var(--color-surface-elevated)',
                color: theme.palette.text.primary,
                border: `1px solid ${theme.palette.divider}`,
              }),
            },
          }}
          IconComponent={ArrowIcon}
          endAdornment={
            endAdornment && (
              <EndAdornmentContainer position="end">
                <EndAdornmentText>{endAdornment}</EndAdornmentText>
              </EndAdornmentContainer>
            )
          }
        >
          {defaultLabel && <StyledMenuItem value="">{defaultLabel}</StyledMenuItem>}
          {options.map((option) => (
            <StyledMenuItem key={option.value} width={width} value={option.value}>
              {option.icon ? (
                <div className="d-flex">
                  {option.icon}
                  <span className="m-l-md">{option.label}</span>
                </div>
              ) : (
                option.label
              )}
            </StyledMenuItem>
          ))}
        </StyledSelect>
      </StyledFormControl>
    </>
  );
};

export default Select;
